import { useState } from "react";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import ExportDropdownButton from "@/shared/components/ui/Export/ExportDropdownButton";
import BorderCard from "../components/BorderCard";
import { Maximize2, Minimize2 } from "lucide-react";
import CampaignContactTable from "./CampaignContactTable";
import CardTitle from "../components/CardTitle";
import AnalyticsStepArea from "./AnalyticsStepArea";
import AnalyticsPerformanceInsightArea from "./AnalyticsPerformanceInsightArea";
import { useCampaignId } from "@/features/campaigns/hooks/useCampaignId";
import {
  CONTACT_ANALYSIS_EXPORT_COLUMNS,
  exportCampaignTable,
  fetchAllCampaignLeads,
} from "@/features/campaigns/utils/campaignAnalyticsExport";
import { showError, showSuccess } from "@/shared/utils/toast";

const AnalyticsContent = ({ campaignStatus }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const campaignId = useCampaignId();

  const handleExportContacts = async (format) => {
    try {
      const leads = await fetchAllCampaignLeads(campaignId);
      if (!leads.length) {
        showError("No contacts available to export.");
        return;
      }

      await exportCampaignTable({
        format,
        columns: CONTACT_ANALYSIS_EXPORT_COLUMNS,
        rows: leads,
        filename: "contacts-analysis",
        title: "Contacts Analysis",
      });
      showSuccess("Contacts Analysis exported successfully.");
    } catch (error) {
      showError(error.message || "Failed to export contacts analysis.");
    }
  };

  return (
    <div className="flex h-full min-h-0 flex-col w-full gap-4">
      {!isExpanded && (
        <AnalyticsPerformanceInsightArea campaignStatus={campaignStatus} />
      )}
      <div className="flex w-full min-h-0 flex-1 gap-4">
        {!isExpanded && <AnalyticsStepArea />}
        <div
          className={`flex min-h-0 min-w-0 flex-col ${isExpanded ? "w-full" : "w-[55%]"}`}
        >
          <BorderCard>
            <CardTitle text={"Contacts Analysis"} />
            <div className="flex items-center gap-2">
              <ExportDropdownButton onExport={handleExportContacts} />
              <SecondaryButton
                title={isExpanded ? "Collapse" : "Expand"}
                onClick={() => setIsExpanded((prev) => !prev)}
                icon={
                  isExpanded ? (
                    <Minimize2 size={16} className="text-gray-700" />
                  ) : (
                    <Maximize2 size={16} className="text-gray-700" />
                  )
                }
              />
            </div>
          </BorderCard>
          <BorderCard
            variant="bottom"
            className="flex min-h-0 flex-1 flex-col"
          >
            <div className="flex-1 min-h-0 overflow-hidden">
              <CampaignContactTable />
            </div>
          </BorderCard>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsContent;
